var SERVER_URL = "https://i13hpc29.ira.uka.de/api/";
//"https://transcriptions.dataforlearningmachines.com/api/"; //"http://127.0.0.1:8000";
var OFFLINE = true;
const ONE_FILE_MODE = true;
const MODE_MENU = false;
const DEFAULT_MODE = "normal";
var MOCK_BACKEND=false;

export { SERVER_URL, MOCK_BACKEND, OFFLINE, ONE_FILE_MODE, DEFAULT_MODE, MODE_MENU };
